import React, { useState } from 'react';
import InfoIcon from '../../../dist/icons/InfoIcon';

const AuthSelectField = ({name,dvalue="", tabs, label,fnc, children}) => {
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        fnc(e.target.value);
        if(e.target.value.length <= 0){
            setError(true);
            setMessage('Ce champs ne doit pas être vide');
        }else{
            setError(false);
            setMessage(null);
        }
    }

    return (
        <>
        <div className={`ipay-ui-auth__textfield ${(!error) ? '' : 'is--error'}`}>
            
            <select  name={name} defaultValue={dvalue} onChange={handleChange} required>
                <option value=""></option>
                {
                    tabs && tabs.map((tab, index) => (
                        <option key={index} value={tab.value}>{tab.label}</option>
                    ))
                }
            </select>
            <label>{label}</label>
            <div className='ipay-ui-auth-textfield__info'>
                <InfoIcon/>
            </div>
            <div className='ipay-ui-auth-textfield__tooltip'>
                {children}
            </div>
        </div>
        {
            (error) ? (
                <div className='ipay-ui-auth__textfield-error'>
                    <p>{message}</p>
                </div>
            ) : (null)
        }
       
        </>
        
    );
};

export default AuthSelectField;